<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Unidades Consumidoras
      </div>
      <v-data-table
        :headers="headers"
        :items="dados"
        :server-items-length="total"
        :options.sync="options"
        loading-text="Carregando... Por favor aguarde"
        :loading="carregando"
        class="elevation-1 base_table"
        disable-sort
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <div class="py-2 px-2">
              <v-row no-gutters>
                <v-form @submit.prevent="buscaItens()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
                <v-autocomplete
                  class="ml-3"
                  v-if="nivelUsuarioApelido === 'M'"
                  :menu-props="{ offsetY: true}"
                  :items="distribuidores"
                  label="Distribuidor"
                  append-icon="expand_more"
                  v-model="distribuidor"
                  hide-details=""
                  :loading="loading || loadingDistribuidores"
                  :disabled="loading || loadingDistribuidores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
                <v-autocomplete
                  v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'"
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="integradores"
                  label="Integrador"
                  append-icon="expand_more"
                  v-model="integrador"
                  hide-details=""
                  :loading="loading || loadingIntegradores"
                  :disabled="loading || loadingIntegradores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="concessionarias"
                  label="Concessionárias"
                  append-icon="expand_more"
                  v-model="concessionaria"
                  hide-details=""
                  :loading="loading || loadingConcessionarias"
                  :disabled="loading || loadingConcessionarias"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
              </v-row>
            </div>
            <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="exportXls()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item @click="exportPdf()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">assignment</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para PDF</v-list-item-title>
                  </v-list-item> -->
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </template>
        <template v-slot:item.faturas="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="primary" @click="openDialogFaturas(item)">
                receipt
              </v-icon>
            </template>
            <span>Faturas</span>
          </v-tooltip>
        </template>
        <template v-slot:item.credito="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="primary" @click="openDialogCredito(item)">
                savings
              </v-icon>
            </template>
            <span>Crédito</span>
          </v-tooltip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="opendialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <div class="ui-create">
      <v-btn color="primary" elevation="3" @click="openDialog()" :loading="loading" :disabled="loading">
        <v-icon color="white" x-large>add</v-icon>
      </v-btn>
    </div>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Unidade
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDialogDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Unidade <b class="text-primary">{{unidade ? unidade.uco_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="cancelDialogDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeUnidade()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="700px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{unidade.uuid_uco_id ? 'Editar' : 'Nova'}} unidade consumidora
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formCadastro">
          <v-row>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-text-field
                v-model="unidade.uco_nome"
                label="Nome*"
                autofocus
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="unidade.uco_classificacao"
                :items="classificacoes"
                clearable
                clear-icon="close"
                label="Classificação*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="unidade.uco_codigo"
                label="Código da unidade consumidora*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="unidade.uco_tipo"
                :items="tipos"
                clearable
                clear-icon="close"
                label="Tipo*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-autocomplete
                v-model="unidade.uuid_con_id"
                autocomplete="off"
                :items="concessionarias"
                :loading="salvando || loadingConcessionarias"
                :disabled="salvando || loadingConcessionarias"
                label="Concessionária*"
                :rules="[rules.required]"
                append-icon="expand_more"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="unidade.uco_modalidade"
                :items="modalidades"
                clearable
                clear-icon="close"
                label="Modalidade Tarifária*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="unidade.uuid_cli_id"
                :items="clientes"
                clearable
                clear-icon="close"
                label="Cliente"
                append-icon="expand_more"
                :loading="salvando || loadingClientes"
                :disabled="salvando || loadingClientes"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="unidade.uco_numero_instalacao"
                label="Número de instalação"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                :items="baseTarifariaEnum"
                label="Base Tarifária*"
                append-icon="expand_more"
                v-model="unidade.uco_base_tarifaria"
                :disabled="salvando"
                :loading="salvando"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="unidade.uco_uf"
                :items="estados"
                label="Estado*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="unidade.uco_usuario"
                label="Usuário"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="unidade.uco_senha"
                label="Senha"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditUnidade()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogFaturas"
      persistent
      max-width="1000px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="9">
            Faturas
          </v-col>
          <v-col cols="3" class="text-right">
            <v-row no-gutters align="center" justify="end">
              <v-btn v-if="unidade" @click="dialogNovaFatura = true" color="primary" class="mr-3">Nova Fatura</v-btn>
              <v-icon @click="dialogFaturas = false">close</v-icon>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div>
          <v-data-table
            :headers="headersFaturas"
            :items="dadosFaturas"
            :search="searchFaturas"
            multi-sort
            :loading="loadingFaturas"
            loading-text="Carregando... Por favor aguarde"
            fixed-header
            height="400px"
            class="elevation-1 base_table"
            :footer-props="{
              itemsPerPageOptions: [5,10,15,20,25,50,100],
              showFirstLastPage: true,
              firstIcon: 'skip_previous',
              lastIcon: 'skip_next',
              prevIcon: 'chevron_left',
              nextIcon: 'chevron_right'
            }"
            :header-props="{
              sortIcon: 'north',
            }"
          >
            <template v-slot:top>
              <v-row no-gutters align="center" justify="space-between">
                <div class="py-2 px-2 table_search_area">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="searchFaturas"
                    outlined
                    label="Busca"
                  ></v-text-field>
                </div>
                <div>
                  <v-menu
                    bottom
                    center
                    offset-y
                    max-height="400"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        Exportar
                        <v-icon>arrow_drop_down</v-icon>
                      </div>
                    </template>
                    <v-list>
                      <v-list-item @click="exportXls('faturas')">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">receipt_long</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para XLS</v-list-item-title>
                      </v-list-item>
                      <!-- <v-list-item @click="exportPdf('faturas')">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">assignment</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para PDF</v-list-item-title>
                      </v-list-item> -->
                    </v-list>
                  </v-menu>
                </div>
              </v-row>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-row no-gutters align="center" justify="center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="openNovaFatura(item)" color="primary" class="mr-2">
                      edit
                    </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="openDialogDeleteFatura(item)" color="primary" class="ml-2">
                      delete
                    </v-icon>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </v-row>
            </template>
            <template v-slot:item.arquivo="{ item }">
              <div v-if="item.ucf_arquivo_link">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <a :href="item.ucf_arquivo_link" v-bind="attrs" v-on="on" target="_blank">{{item.ucf_nome_arquivo}}</a>
                  </template>
                  <span>Visualizar arquivo</span>
                </v-tooltip>
              </div>
              <div v-else class="pl-3">
                -
              </div>
            </template>
          </v-data-table>
        </div>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            @click="dialogFaturas = false"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluirFatura" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Fatura
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDialogDeleteFatura()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Fatura <b class="text-primary">{{fatura ? fatura.ucf_id : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="cancelDialogDeleteFatura()"
          >
            Cancelar
          </v-btn>
          <v-btn
            :loading="salvando"
            :disabled="salvando"
            color="success"
            @click="removeFatura()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNovaFatura"
      persistent
      max-width="600px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{fatura.uuid_ucf_id ? 'Editar' : 'Nova'}} Fatura
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogFaturas()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formFatura">
          <v-row>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <vuetify-money
                lazy-validation
                v-model="fatura.ucf_valor_faturado"
                :backgroundColor="$vuetify.theme.dark ? '#1e1e1e00' : '#fff'"
                :disabled="salvando"
                :loading="salvando"
                outlined
                :rules="[rules.required]"
                :options="optionsMoney"
                valueWhenIsEmpty="0,00"
                label="Valor faturado*"
              ></vuetify-money>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-menu
                ref="calendarDataInicio"
                v-model="calendarDataInicio"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    label="Início do ciclo*"
                    :rules="[rules.required]"
                    append-icon="calendar_today"
                    :loading="salvando"
                    :disabled="salvando"
                    v-bind="attrs"
                    v-on="on"
                    v-model="dataFormatadaInicio"
                    v-mask="'##/##/####'"
                    @input="() => {
                      calendarDataInicio = false
                      fatura.ucf_inicio_ciclo = $root.Formatter.parseDate(dataFormatadaInicio)
                      updatePickerModalDataInicio = $root.Formatter.parseDate(dataFormatadaInicio)
                    }"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :picker-date.sync="updatePickerModalDataInicio"
                  year-icon="calendar_today"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                  :max="fatura.ucf_fim_ciclo"
                  :loading="salvando"
                  :disabled="salvando"
                  v-model="dataInicio"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-menu
                ref="calendarDataFim"
                v-model="calendarDataFim"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    label="Fim do ciclo*"
                    :rules="[rules.required]"
                    append-icon="calendar_today"
                    :loading="salvando"
                    :disabled="salvando"
                    v-bind="attrs"
                    v-on="on"
                    v-model="dataFormatadaFim"
                    v-mask="'##/##/####'"
                    @input="() => {
                      calendarDataFim = false
                      fatura.ucf_fim_ciclo = $root.Formatter.parseDate(dataFormatadaFim)
                      updatePickerModalDataFim = $root.Formatter.parseDate(dataFormatadaFim)
                    }"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :picker-date.sync="updatePickerModalDataFim"
                  year-icon="calendar_today"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                  :min="fatura.ucf_inicio_ciclo"
                  :loading="salvando"
                  :disabled="salvando"
                  v-model="dataFim"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <vuetify-money
                lazy-validation
                v-model="fatura.ucf_valor_tarifa"
                :backgroundColor="$vuetify.theme.dark ? '#1e1e1e00' : '#fff'"
                :disabled="salvando"
                :loading="salvando"
                outlined
                :rules="[rules.required]"
                :options="optionsMoney"
                valueWhenIsEmpty="0,00"
                label="Tarifa sem impostos (R$/kWh)*"
              ></vuetify-money>
            </v-col>
            <v-col cols="6" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <vuetify-money
                lazy-validation
                v-model="fatura.ucf_iluminacao_publica"
                :backgroundColor="$vuetify.theme.dark ? '#1e1e1e00' : '#fff'"
                :disabled="salvando"
                :loading="salvando"
                outlined
                :rules="[rules.required]"
                :options="optionsMoney"
                valueWhenIsEmpty="0,00"
                label="Contribuição iluminação pública (R$)*"
              ></vuetify-money>
            </v-col>
            <v-col cols="6" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="fatura.ucf_consumida"
                label="Consumida (kWh)*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="fatura.ucf_faturada"
                label="Faturada(kWh)*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <vuetify-money
                lazy-validation
                v-model="fatura.ucf_tarifa_compensada"
                :backgroundColor="$vuetify.theme.dark ? '#1e1e1e00' : '#fff'"
                :disabled="salvando"
                :loading="salvando"
                outlined
                :options="optionsMoney"
                valueWhenIsEmpty="0,00"
                label="Tarifa comp. (R$)"
              ></vuetify-money>
            </v-col>
            <v-col cols="6" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="fatura.ucf_energia_compensada"
                label="Energia Comp. (kWh)*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="fatura.ucf_energia_injetada"
                label="Energia injetada (kWh)*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="fatura.ucf_situacao"
                :items="situacoes"
                clearable
                clear-icon="close"
                label="Situação*"
                append-icon="expand_more"
                :loading="salvando"
                :rules="[rules.required]"
                :disabled="salvando"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="6" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <vuetify-money
                lazy-validation
                v-model="fatura.ucf_demanda_sem_impostos"
                :backgroundColor="$vuetify.theme.dark ? '#1e1e1e00' : '#fff'"
                :disabled="salvando"
                :loading="salvando"
                outlined
                :options="optionsMoney"
                valueWhenIsEmpty="0,00"
                label="Demanda sem impostos (R$/kWh)"
              ></vuetify-money>
            </v-col>
            <v-col cols="6" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="fatura.ucf_demanda"
                label="Demanda (kWh)"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="fatura.ucf_nome_arquivo"
                label="Nome do arquivo"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="fatura.ucf_arquivo"
                prepend-icon="description"
                label="Adicionar fatura"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                v-if="!fatura.ucf_arquivo_link"
                outlined
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="fatura.ucf_arquivo_link">
              <v-row no-gutters justify="space-between" align="center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <a :href="fatura.ucf_arquivo_link" v-bind="attrs" v-on="on" target="_blank">Arquivo: {{fatura.ucf_nome_arquivo}}</a>
                  </template>
                  <span>Visualizar arquivo</span>
                </v-tooltip>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="dialogDeletarArquivo = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                    </template>
                    <span>Remover arquivo</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-col>
            <!-- {{fatura.ucf_arquivo instanceof Object ? 'Objeto' : 'link?' }} -->
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogFaturas()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditFatura()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarArquivo" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Arquivo
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarArquivo = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja remover este arquivo?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarArquivo = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeArquivo()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogCredito"
      persistent
      max-width="1000px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="9">
            Lançamento de crédito
          </v-col>
          <v-col cols="3" class="text-right">
            <v-row no-gutters align="center" justify="end">
              <v-btn v-if="hasUnidadeAndSistemaCredito()" @click="dialogNovoCredito = true" color="primary" class="mr-3">Novo Crédito</v-btn>
              <v-icon @click="dialogCredito = false">close</v-icon>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div>
          <v-data-table
            :headers="headersCreditos"
            :items="dadosCreditos"
            :search="searchCreditos"
            multi-sort
            fixed-header
            :loading="loadingCreditos"
            loading-text="Carregando... Por favor aguarde"
            height="400px"
            class="elevation-1 base_table"
            :footer-props="{
              itemsPerPageOptions: [5,10,15,20,25,50,100],
              showFirstLastPage: true,
              firstIcon: 'skip_previous',
              lastIcon: 'skip_next',
              prevIcon: 'chevron_left',
              nextIcon: 'chevron_right'
            }"
            :header-props="{
              sortIcon: 'north',
            }"
          >
            <template v-slot:top>
              <v-row no-gutters align="center" justify="space-between">
                <div class="py-2 px-2 table_search_area">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="searchCreditos"
                    outlined
                    label="Busca"
                  ></v-text-field>
                </div>
                <div>
                  <v-menu
                    bottom
                    center
                    offset-y
                    max-height="400"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        Exportar
                        <v-icon>arrow_drop_down</v-icon>
                      </div>
                    </template>
                    <v-list>
                      <v-list-item @click="exportXls('creditos')">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">receipt_long</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para XLS</v-list-item-title>
                      </v-list-item>
                      <!-- <v-list-item @click="exportPdf('creditos')">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">assignment</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para PDF</v-list-item-title>
                      </v-list-item> -->
                    </v-list>
                  </v-menu>
                </div>
              </v-row>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-row no-gutters align="center" justify="center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="openNovoCredito(item)" color="primary" class="mr-2">
                      edit
                    </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="opendialogDeleteCredito(item)" color="primary" class="ml-2">
                      delete
                    </v-icon>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </v-row>
            </template>
          </v-data-table>
        </div>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            @click="dialogCredito = false"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExluirCredito" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Crédito
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDialogDeleteCredito()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Crédito <b class="text-primary">{{credito ? credito.ucc_id : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="cancelDialogDeleteCredito()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeCredito()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNovoCredito"
      persistent
      max-width="600px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{credito.uuid_ucc_id ? 'Editar' : 'Novo'}} lançamento de crédito
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogCredito()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formCredito">
          <v-row>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0" v-if="unidade.sistema_credito">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="credito.uuid_usi_id"
                :items="sistemaCreditoUsinas"
                clearable
                clear-icon="close"
                label="Usina*"
                append-icon="expand_more"
                :loading="salvando || loadingUsinas"
                :rules="[rules.required]"
                :disabled="salvando || loadingUsinas"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="credito.ucc_posto_tarifario"
                :items="postos"
                clearable
                clear-icon="close"
                label="Posto tarifário*"
                append-icon="expand_more"
                :loading="salvando"
                :rules="[rules.required]"
                :disabled="salvando"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="credito.ucc_quantidade"
                label="Quantidade(kWh)*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-menu
                ref="calendarData"
                v-model="calendarData"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    label="Vigência*"
                    :rules="[rules.required]"
                    append-icon="calendar_today"
                    :loading="salvando"
                    :disabled="salvando"
                    v-bind="attrs"
                    v-on="on"
                    v-model="dataFormatada"
                    v-mask="'##/##/####'"
                    @input="() => {
                      calendarData = false
                      credito.ucc_vigencia = $root.Formatter.parseDate(dataFormatada)
                      updatePickerModalData = $root.Formatter.parseDate(dataFormatada)
                    }"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :picker-date.sync="updatePickerModalData"
                  year-icon="calendar_today"
                  prev-icon="chevron_left"
                  next-icon="chevron_right"
                  :loading="salvando"
                  :disabled="salvando"
                  v-model="data"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-textarea
                outlined
                no-resize
                rows="3"
                v-model="credito.ucc_observacao"
                label="Observações"
                :disabled="salvando"
                :loading="salvando"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogCredito()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditCredito()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
import moment from 'moment'
import RelatorioBase from '@components/impressoes/RelatorioBase.vue'

export default {
  data () {
    return {
      loading: true,
      salvando: false,
      dialogNovo: false,
      dialogFaturas: false,
      dialogExcluirFatura: false,
      dialogExcluir: false,
      dialogNovaFatura: false,
      dialogCredito: false,
      dialogExluirCredito: false,
      dialogNovoCredito: false,
      loadingCreditos: false,
      usinas: [],
      dialogDeletarArquivo: false,
      loadingUsinas: false,
      data: '',
      dataFormatada: '',
      updatePickerModalData: '',
      calendarData: false,
      dataInicio: '',
      dataFormatadaInicio: '',
      updatePickerModalDataInicio: '',
      calendarDataInicio: false,
      dataFim: '',
      dataFormatadaFim: '',
      updatePickerModalDataFim: '',
      calendarDataFim: false,
      concessionaria: null,
      optionsMoney: {
        locale: 'pt-BR',
        prefix: 'R$',
        suffix: '',
        length: 8,
        precision: 2
      },
      estados: [
        { text: 'Acre', value: 'AC' },
        { text: 'Alagoas', value: 'AL' },
        { text: 'Amapá', value: 'AP' },
        { text: 'Amazonas', value: 'AM' },
        { text: 'Bahia', value: 'BA' },
        { text: 'Ceará', value: 'CE' },
        { text: 'Espírito Santo', value: 'ES' },
        { text: 'Goiás', value: 'GO' },
        { text: 'Maranhão', value: 'MA' },
        { text: 'Mato Grosso', value: 'MT' },
        { text: 'Mato Grosso do Sul', value: 'MS' },
        { text: 'Minas Gerais', value: 'MG' },
        { text: 'Pará', value: 'PA' },
        { text: 'Paraíba', value: 'PB' },
        { text: 'Paraná', value: 'PR' },
        { text: 'Pernambuco', value: 'PE' },
        { text: 'Piauí', value: 'PI' },
        { text: 'Rio de Janeiro', value: 'RJ' },
        { text: 'Rio Grande do Norte', value: 'RN' },
        { text: 'Rio Grande do Sul', value: 'RS' },
        { text: 'Rondônia', value: 'RO' },
        { text: 'Roraima', value: 'RR' },
        { text: 'Santa Catarina', value: 'SC' },
        { text: 'São Paulo', value: 'SP' },
        { text: 'Sergipe', value: 'SE' },
        { text: 'Tocantins', value: 'TO' },
        { text: 'Distrito Federal', value: 'DF' }
      ],
      situacoes: [
        {
          text: 'Informado',
          value: 'I'
        },
        {
          text: 'Falha',
          value: 'F'
        }
      ],
      rules: {
        required: value => !!value || 'Obrigatório.'
      },
      classificacoes: [
        {
          text: 'A1',
          value: 'A1'
        },
        {
          text: 'A2',
          value: 'A2'
        },
        {
          text: 'A3',
          value: 'A3'
        },
        {
          text: 'A3a',
          value: 'A3a'
        },
        {
          text: 'A4',
          value: 'A4'
        },
        {
          text: 'AS',
          value: 'AS'
        },
        {
          text: 'B1',
          value: 'B1'
        },
        {
          text: 'B2',
          value: 'B2'
        },
        {
          text: 'B3',
          value: 'B3'
        },
        {
          text: 'B4',
          value: 'B4'
        }
      ],
      tipos: [
        {
          text: 'Comercial',
          value: 1
        },
        {
          text: 'Rural Agroindustrial',
          value: 2
        },
        {
          text: 'Residencial',
          value: 3
        },
        {
          text: 'Comercial Outros Serviços e Outras Atividades',
          value: 4
        },
        {
          text: 'Comercial Serviços de Comunicações e Telecomunicações',
          value: 5
        },
        {
          text: 'Industrial Industrial',
          value: 6
        },
        {
          text: 'Rural Agropecuária Rural',
          value: 7
        },
        {
          text: 'Poder Público Federal',
          value: 8
        }
      ],
      modalidades: [
        {
          text: 'Convencional',
          value: 'Convencional'
        },
        {
          text: 'Optante B',
          value: 'Optante B'
        },
        {
          text: 'Tarifa Branca',
          value: 'Tarifa Branca'
        },
        {
          text: 'Tarifa Verde',
          value: 'Tarifa Verde'
        },
        {
          text: 'Tarifa Azul',
          value: 'Tarifa Azul'
        }
      ],
      search: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'uco_id'
        },
        { text: 'Cliente', value: 'cliente.cli_nome' },
        { text: 'Nome', value: 'uco_nome' },
        { text: 'Concessionária', value: 'concessionaria.con_nome' },
        { text: 'Código', value: 'uco_codigo' },
        {
          text: 'Faturas',
          value: 'faturas',
          align: 'center',
          sortable: false,
          width: 110
        },
        {
          text: 'Crédito',
          value: 'credito',
          align: 'center',
          sortable: false,
          width: 110
        },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      baseTarifariaEnum: [
        { text: 'Base Econômica', value: 'BASE_ECONOMICA' },
        { text: 'Tarifa de Aplicação', value: 'APLICACAO' }
      ],
      loadingConcessionarias: false,
      concessionarias: [],
      dados: [],
      searchFaturas: '',
      headersFaturas: [
        {
          text: 'ID',
          align: 'start',
          value: 'ucf_id'
        },
        { text: 'Início do ciclo', value: 'ucf_inicio_ciclo' },
        { text: 'Fim do ciclo', value: 'ucf_fim_ciclo' },
        { text: 'Valor faturado', value: 'ucf_valor_faturado' },
        { text: 'Valor da tarifa', value: 'ucf_valor_tarifa' },
        { text: 'Arquivo', value: 'arquivo', sortable: false },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      loadingFaturas: false,
      dadosFaturas: [],
      searchCreditos: '',
      headersCreditos: [
        {
          text: 'ID',
          align: 'start',
          value: 'ucc_id'
        },
        { text: 'Usina', value: 'usina.usi_nome' },
        { text: 'Quantidade', value: 'ucc_quantidade' },
        { text: 'Vigência', value: 'ucc_vigencia' },
        { text: 'Posto Tarifário', value: 'ucc_posto_tarifario' },
        { text: 'Observações', value: 'ucc_observacao' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dadosCreditos: [],
      postos: [
        {
          text: 'Ponta',
          value: 'P'
        },
        {
          text: 'Fora Ponta',
          value: 'FP'
        }
      ],
      unidade: {
        uco_codigo: '',
        uco_nome: '',
        uco_classificacao: '',
        uco_tipo: '',
        uco_modalidade: '',
        uuid_con_id: '',
        uco_usuario: '',
        uco_senha: '',
        uco_numero_instalacao: '',
        uuid_cli_id: '',
        usinaNome: ''
      },
      fatura: {
        ucf_valor_faturado: '',
        ucf_inicio_ciclo: '',
        ucf_fim_ciclo: '',
        ucf_valor_tarifa: '',
        ucf_consumida: '',
        ucf_faturada: '',
        ucf_tarifa_compensada: '',
        ucf_energia_compensada: '',
        ucf_energia_injetada: '',
        ucf_situacao: '',
        ucf_nome_arquivo: '',
        ucf_arquivo: []
      },
      credito: {
        uuid_usi_id: '',
        ucc_quantidade: '',
        ucc_vigencia: '',
        ucc_posto_tarifario: '',
        ucc_observacao: ''
      },
      sistemaCreditoUsinas: [],
      loadingClientes: false,
      clientes: [],
      nivelUsuarioApelido: null,
      searchFinal: null,
      total: 0,
      options: {},
      carregando: false,
      distribuidor: null,
      integrador: null,
      distribuidores: [],
      integradores: []
    }
  },
  watch: {
    data () {
      this.dataFormatada = moment(this.data).format('L')
      this.credito.ucc_vigencia = this.$root.Formatter.parseDate(this.dataFormatada)
      this.calendarData = false
    },
    dataInicio () {
      this.dataFormatadaInicio = moment(this.dataInicio).format('L')
      this.fatura.ucf_inicio_ciclo = this.$root.Formatter.parseDate(this.dataFormatadaInicio)
      this.calendarDataInicio = false
    },
    dataFim () {
      this.dataFormatadaFim = moment(this.dataFim).format('L')
      this.fatura.ucf_fim_ciclo = this.$root.Formatter.parseDate(this.dataFormatadaFim)
      this.calendarDataFim = false
    },
    options: {
      handler () {
        this.getDataFromApi()
      },
      deep: true
    }
  },
  methods: {
    async exportXls (type = null) {
      this.loadingXls = true
      Api.post('relatorios', {
        headers: this.someHeader(!type ? this.headers : type === 'faturas' ? this.headersFaturas : this.headersCreditos),
        unidade: this.unidade ? this.unidade.uuid_uco_id : null,
        distribuidor: this.distribuidor,
        integrador: this.integrador,
        busca: this.searchFinal,
        concessionaria: this.concessionaria,
        type: !type ? 'unidades-consumidoras' : type === 'faturas' ? 'unidades-consumidoras-faturas' : 'unidades-consumidoras-credito'
      })
        .then(res => {
          const baseUrl = window.location.origin
          this.downloadXls(baseUrl + '/' + res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    exportPdf (type = null) {
      this.$root.Printer.openDialog(this, {
        titulo: type === 'faturas' ? 'Faturas' : type === 'creditos' ? 'Créditos' : 'Unidades consumidoras',
        component: RelatorioBase, // componente com o layout a ser impresso
        data: !type ? this.dados : type === 'faturas' ? this.dadosFaturas : this.dadosCreditos,
        headers: this.someHeader(!type ? this.headers : type === 'faturas' ? this.headersFaturas : this.headersCreditos), // dados para alimentar o componente, por padrão ele chegará como o props data no componente
        css: `` // Classes css que são adicionados na página de impressão
      })
    },
    someHeader (headers) {
      let cabecalhos = []
      headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Faturas' && header.text !== 'Crédito' && header.text !== 'Arquivo') cabecalhos.push(header)
      })
      return cabecalhos
    },
    isObject (val) {
      return val instanceof Object
    },
    loadFunctions () {
      let filters = this.$route.query
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.concessionaria) this.concessionaria = filters.concessionaria
      if (filters.busca) {
        this.search = filters.busca
        this.searchFinal = filters.busca
      }
      this.getDataFromApi()
      this.getIntegradores()
      this.getDistribuidores()
      this.getConcessionarias()
      this.getUsinas()
      this.getClientes()
    },
    buscaItens () {
      this.searchFinal = this.search
      this.options.page = 1
      this.applyFilter()
    },
    limparBusca () {
      this.search = null
      this.searchFinal = null
      this.options.page = 1
      this.applyFilter()
    },
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }

      let query = Object.assign({},
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.searchFinal ? { busca: this.searchFinal } : '',
        this.concessionaria ? { concessionaria: this.concessionaria } : ''
      )

      this.$router.replace({name: 'UnidadeConsumidora', query: query}).catch(() => {})
      this.dados = []
      this.distribuidorAnterior = this.distribuidor
      this.getIntegradores(this.distribuidor)
      this.getDataFromApi()
    },
    async getDataFromApi () {
      this.carregando = true
      this.total = 0
      this.dados = []
      let filtro = '&filtro='

      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 10
      if (page) {
        pagina = page
      }
      if (itemsPerPage) {
        itensPagina = itemsPerPage
      }

      if (this.distribuidor) {
        filtro += '&distribuidor=' + this.distribuidor
      }
      if (this.integrador) {
        filtro += '&integrador=' + this.integrador
      }
      if (this.searchFinal) {
        filtro += '&busca=' + this.searchFinal
      }
      if (this.concessionaria) {
        filtro += '&concessionaria=' + this.concessionaria
      }

      await Api.get(`unidades-consumidoras?page=${pagina}&per_page=${itensPagina}${filtro}`)
        .then(res => {
          if (res.data && res.data.data && res.data.data.length > 0) {
            this.total = res.data.total
            this.dados = res.data.data
          }
          this.carregando = false
          this.loading = false
        })
        .catch(err => {
          this.carregando = false
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as unidades consumidoras!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getConcessionarias () {
      this.loadingConcessionarias = true
      await Api.get('concessionarias')
        .then(res => {
          var arrayCon = []
          res.data.map(con => {
            arrayCon.push({
              'text': con.con_nome,
              'value': con.uuid_con_id
            })
          })
          this.concessionarias = arrayCon
          this.loadingConcessionarias = false
        })
        .catch(err => {
          this.loadingConcessionarias = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as concessionárias!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getUsinas () {
      this.loadingUsinas = true
      await Api.get('usinas')
        .then(res => {
          var arrayUsi = []
          res.data.map(usi => {
            arrayUsi.push({
              'text': usi.usi_nome,
              'value': usi.uuid_usi_id
            })
          })
          this.usinas = arrayUsi
          this.loadingUsinas = false
        })
        .catch(err => {
          this.loadingUsinas = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as usinas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getClientes () {
      this.loadingClientes = true
      await Api.get('clientes')
        .then(res => {
          var arrayCli = []
          res.data.map(cli => {
            arrayCli.push({
              'text': cli.cli_nome,
              'value': cli.uuid_cli_id
            })
          })
          this.clientes = arrayCli
          this.loadingClientes = false
        })
        .catch(err => {
          this.loadingClientes = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os clientes!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegradores (distribuidor = null) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `integradores/distribuidor/${distribuidor}`
      }

      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          this.integradores = arrayInt
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getDistribuidores () {
      this.loadingDistribuidores = true
      await Api.get('distribuidores')
        .then(res => {
          var arrayDists = []
          res.data.map(dist => {
            arrayDists.push({
              'text': dist.dis_nome,
              'value': dist.uuid_dis_id
            })
          })
          this.distribuidores = arrayDists
          this.loadingDistribuidores = false
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    openNovo (item) {
      this.salvando = true
      this.dialogNovo = true

      Api.get('unidades-consumidoras/' + item.uuid_uco_id)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.unidade = JSON.parse(JSON.stringify(response.data))
          if (response.data.cliente) {
            this.unidade.uuid_cli_id = response.data.cliente.uuid_cli_id
          }
          this.unidade.uuid_con_id = response.data.concessionaria.uuid_con_id
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados da unidade!',
            color: 'error'
          })
        })
    },
    saveEditUnidade () {
      if (!this.$refs.formCadastro.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'unidades-consumidoras/novo'
      if (this.unidade.uuid_uco_id) {
        endpoint = 'unidades-consumidoras/edita'
      }
      Api.post(endpoint, this.unidade)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialog()
          this.getDataFromApi()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    openDialog () {
      this.unidade = {
        uco_codigo: '',
        uco_nome: '',
        uco_classificacao: '',
        uco_tipo: '',
        uco_modalidade: '',
        uuid_con_id: '',
        uco_usuario: '',
        uco_senha: '',
        uco_numero_instalacao: '',
        uuid_cli_id: '',
        usinaNome: ''
      }
      if (this.$refs.formCadastro) {
        this.$refs.formCadastro.resetValidation()
      }
      this.dialogNovo = true
    },
    closeDialog () {
      this.unidade = {
        uco_codigo: '',
        uco_nome: '',
        uco_classificacao: '',
        uco_tipo: '',
        uco_modalidade: '',
        uuid_con_id: '',
        uco_usuario: '',
        uco_senha: '',
        uco_numero_instalacao: '',
        uuid_cli_id: '',
        usinaNome: ''
      }
      if (this.$refs.formCadastro) {
        this.$refs.formCadastro.resetValidation()
      }
      this.dialogNovo = false
    },
    opendialogDelete (item) {
      this.unidade = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelDialogDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    removeUnidade () {
      this.salvando = true
      Api.delete(`unidades-consumidoras/remove/${this.unidade.uuid_uco_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getDataFromApi()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover unidade!',
            color: 'error'
          })
        })
    },
    openDialogFaturas (item) {
      this.unidade = JSON.parse(JSON.stringify(item))
      this.dialogFaturas = true
      this.getFaturas()
    },
    openDialogCredito (item) {
      this.unidade = JSON.parse(JSON.stringify(item))
      if (this.unidade.sistema_credito.length) {
        this.sistemaCreditoUsinas = []
        this.unidade.sistema_credito.forEach(sistemaCredito => {
          if (sistemaCredito.usina && !this.sistemaCreditoUsinas.find(usina => usina.value === sistemaCredito.usina.uuid_usi_id)) {
            this.sistemaCreditoUsinas.push({
              'text': sistemaCredito.usina.usi_nome,
              'value': sistemaCredito.usina.uuid_usi_id
            })
          }
        })
      }
      this.dialogCredito = true
      this.getCreditos()
    },
    async getCreditos () {
      this.loadingCreditos = true
      await Api.get('unidades-consumidoras/' + this.unidade.uuid_uco_id + '/lancamento-credito')
        .then(res => {
          res.data.map(item => {
            item.ucc_vigencia = item.ucc_vigencia ? moment(item.ucc_vigencia).format('DD/MM/YYYY') : ''
            if (item.ucc_posto_tarifario === 'FP') {
              item.ucc_posto_tarifario = 'Fora Ponta'
            } else {
              item.ucc_posto_tarifario = 'Ponta'
            }
          })
          this.dadosCreditos = res.data
          this.loadingCreditos = false
        })
        .catch(err => {
          this.loadingCreditos = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os créditos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    openNovoCredito (item) {
      this.salvando = true
      this.dialogNovoCredito = true
      Api.get('unidades-consumidoras/' + this.unidade.uuid_uco_id + '/lancamento-credito/' + item.uuid_ucc_id)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.credito = JSON.parse(JSON.stringify(response.data))
          this.credito.uuid_usi_id = response.data.usina.uuid_usi_id
          const credito = this.unidade.sistema_credito.find(sistemaCredito => sistemaCredito.usina && sistemaCredito.usina.uuid_usi_id === response.data.usina.uuid_usi_id)
          if (credito) {
            this.credito.usinaNome = credito.usina.usi_nome
            this.credito.uuid_usi_id = credito.usina.uuid_usi_id
          }
          this.data = response.data.ucc_vigencia
          if (this.data) {
            this.dataFormatada = moment(this.data).format('L')
            this.updatePickerModalData = this.$root.Formatter.parseDate(this.dataFormatada)
          }
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados da unidade!',
            color: 'error'
          })
        })
    },
    saveEditCredito () {
      if (!this.$refs.formCredito.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'unidades-consumidoras/' + this.unidade.uuid_uco_id + '/lancamento-credito/novo'
      if (this.credito.uuid_ucc_id) {
        endpoint = 'unidades-consumidoras/' + this.unidade.uuid_uco_id + '/lancamento-credito/edita'
      }
      Api.post(endpoint, this.credito)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.sistemaCreditoUsinas = []
          this.closeDialogCredito()
          this.getCreditos()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    opendialogDeleteCredito (item) {
      this.credito = JSON.parse(JSON.stringify(item))
      this.dialogExluirCredito = true
    },
    cancelDialogDeleteCredito () {
      this.closeDialogCredito()
      this.dialogExluirCredito = false
    },
    removeCredito () {
      this.salvando = true
      Api.delete(`unidades-consumidoras/${this.unidade.uuid_uco_id}/lancamento-credito/remove/${this.credito.uuid_ucc_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExluirCredito = false
          this.salvando = false
          this.closeDialogCredito()
          this.getCreditos()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover crédito!',
            color: 'error'
          })
        })
    },
    hasUnidadeAndSistemaCredito () {
      if (this.unidade && this.unidade.sistema_credito && this.unidade.sistema_credito.length) {
        if (this.unidade.sistema_credito.some(sistemaCredito => sistemaCredito.usina)) {
          return true
        }
      }
    },
    async getFaturas () {
      this.loadingFaturas = true
      await Api.get('unidades-consumidoras/' + this.unidade.uuid_uco_id + '/faturas')
        .then(res => {
          res.data.map(item => {
            item.ucf_fim_ciclo = item.ucf_fim_ciclo ? moment(item.ucf_fim_ciclo).format('DD/MM/YYYY') : ''
            item.ucf_inicio_ciclo = item.ucf_inicio_ciclo ? moment(item.ucf_inicio_ciclo).format('DD/MM/YYYY') : ''
            item.ucf_valor_faturado = item.ucf_valor_faturado ? this.$root.Formatter.floatToMoney(item.ucf_valor_faturado) : ''
            item.ucf_valor_tarifa = item.ucf_valor_tarifa ? this.$root.Formatter.floatToMoney(item.ucf_valor_tarifa) : ''
            item.ucf_tarifa_compensada = item.ucf_tarifa_compensada ? this.$root.Formatter.floatToMoney(item.ucf_tarifa_compensada) : ''
          })
          this.dadosFaturas = res.data
          this.loadingFaturas = false
        })
        .catch(err => {
          this.loadingFaturas = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as faturas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    openNovaFatura (item) {
      this.salvando = true
      this.dialogNovaFatura = true
      Api.get('unidades-consumidoras/' + this.unidade.uuid_uco_id + '/faturas/' + item.uuid_ucf_id)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.fatura = JSON.parse(JSON.stringify(response.data))
          this.dataInicio = response.data.ucf_inicio_ciclo
          if (this.dataInicio) {
            this.dataFormatadaInicio = moment(this.dataInicio).format('L')
            this.updatePickerModalDataInicio = this.$root.Formatter.parseDate(this.dataFormatadaInicio)
          }
          this.dataFim = response.data.ucf_fim_ciclo
          if (this.dataFim) {
            this.dataFormatadaFim = moment(this.dataFim).format('L')
            this.updatePickerModalDataFim = this.$root.Formatter.parseDate(this.dataFormatadaFim)
          }
          this.fatura.ucf_arquivo = null
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados da fatura!',
            color: 'error'
          })
        })
    },
    saveEditFatura () {
      if (!this.$refs.formFatura.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'unidades-consumidoras/' + this.unidade.uuid_uco_id + '/faturas/novo'
      if (this.fatura.uuid_ucf_id) {
        endpoint = 'unidades-consumidoras/' + this.unidade.uuid_uco_id + '/faturas/edita'
      }
      if (this.$refs.file) {
        this.fatura.arquivo = this.$refs.file.fileRecords
      }
      const formData = new FormData()
      Object.keys(this.fatura).map((key) => {
        if (key === 'arquivo') {
          if (this.$refs.file) {
            if (this.$refs.file.fileRecords && this.$refs.file.fileRecords.length > 0) {
              formData.append(`arquivo`, this.fatura.arquivo[0].file)
            }
          }
        } else {
          if (this.fatura[key] != null) {
            formData.append(key, this.fatura[key])
          }
        }
      })
      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialogFaturas()
          this.getFaturas()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeArquivo () {
      this.fatura.ucf_nome_arquivo = ''
      this.fatura.ucf_arquivo_link = ''
      this.fatura.remover_arquivo = true
      this.dialogDeletarArquivo = false
    },
    openDialogDeleteFatura (item) {
      this.fatura = JSON.parse(JSON.stringify(item))
      this.dialogExcluirFatura = true
    },
    cancelDialogDeleteFatura () {
      this.closeDialogFaturas()
      this.dialogExcluirFatura = false
    },
    removeFatura () {
      this.salvando = true
      Api.delete(`unidades-consumidoras/${this.unidade.uuid_uco_id}/faturas/remove/${this.fatura.uuid_ucf_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluirFatura = false
          this.salvando = false
          this.closeDialogFaturas()
          this.getFaturas()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover fatura!',
            color: 'error'
          })
        })
    },
    closeDialogFaturas () {
      this.fatura = {
        ucf_valor_faturado: '',
        ucf_inicio_ciclo: '',
        ucf_fim_ciclo: '',
        ucf_valor_tarifa: '',
        ucf_consumida: '',
        ucf_faturada: '',
        ucf_tarifa_compensada: '',
        ucf_energia_compensada: '',
        ucf_energia_injetada: '',
        ucf_situacao: '',
        ucf_nome_arquivo: '',
        ucf_arquivo: []
      }
      this.dataInicio = ''
      this.dataFim = ''
      if (this.$refs.formFatura) {
        this.$refs.formFatura.resetValidation()
      }
      this.dialogNovaFatura = false
    },
    closeDialogCredito () {
      this.credito = {
        ...this.credito,
        uuid_ucc_id: '',
        ucc_quantidade: '',
        ucc_posto_tarifario: '',
        ucc_observacao: ''
      }
      if (this.$refs.formCredito) {
        this.$refs.formCredito.resetValidation()
      }
      this.dialogNovoCredito = false
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        this.user = JSON.parse(localStorage.getItem('user'))
        if (this.user.fk_gru_id_grupo) {
          this.nivelUsuarioApelido = 'M'
        }
        if (this.user.fk_dis_id_distribuidor) {
          this.nivelUsuarioApelido = 'D'
        }
        if (this.user.fk_int_id_integrador) {
          this.nivelUsuarioApelido = 'I'
        }
      }
    }
  },
  updated () {
    this.updateData()
  },
  created () {
    this.updateData()
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.mw_600 {
  max-width: 600px;
}
.v-file-input {
  >>>.v-input__prepend-outer {
    margin-top: 10px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cadastros/UnidadeConsumidora.vue